<template>
  <NavBar v-if="showHeader" @toggle-blur="toggleBlur" />
  <div>
    <div :class="{ blurred: isBodyBlurred }"></div>
    <router-view :key="$route.fullPath" />
  </div>
  <Footer v-if="showFooter" />
</template>

<script>
import NavBar from "@/components/public/NavBar.vue";
import Footer from "@/components/public/Footer.vue";
import { checkAuthUser } from "@/utils/checkAuth";

export default {
  components: { NavBar, Footer },
  data() {
    return {
      isBodyBlurred: false,
      showHeader: true,
      showFooter: true,
    };
  },
  methods: {
    toggleBlur() {
      this.isBodyBlurred = !this.isBodyBlurred;
    },
    async checkUserLogin() {
      this.$store.commit("readUserToken");
      const token = this.$store.state.userToken;

      if (!token) {
        this.$store.commit("clearUserToken");
        return;
      }

      const authResponse = await checkAuthUser(
        "/v2/users/auth/validate",
        token
      );

      if (authResponse.status) {
        this.$store.commit("setUser", authResponse.data || {});
        this.$store.commit("setUserToken", token);
      } else {
        this.$store.commit("clearUserToken");
      }
    },
    applyPageLayout(event) {
      this.showHeader = event.detail?.showHeader !== false;
      this.showFooter = event.detail?.showFooter !== false;
    },
  },
  mounted() {
    this.checkUserLogin();
    window.addEventListener("site-cms:page-layout", this.applyPageLayout);
  },
  unmounted() {
    window.removeEventListener("site-cms:page-layout", this.applyPageLayout);
  },
};
</script>

<style scoped>
.sd {
  background-color: red;
}
.blurred {
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.7;
  position: absolute;
  z-index: 5;
}
</style>
